"use client";
import Link from "next/link";
import Image from "next/image";
import { Clock } from "lucide-react";

// Right "Related Articles" rail.
// posts: [{ id, slug, title, category, readTime, image }]
export default function RelatedArticles({ posts }) {
  if (!posts?.length) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">
          Related Articles
        </p>
        <Link
          href="/blog"
          className="text-[11px] font-medium text-[#9573F7] hover:underline"
        >
          See all →
        </Link>
      </div>

      <div className="flex flex-col gap-3">
        {posts.map((post) => (
          <Link
            key={post.id ?? post.slug}
            href={`/blog/${post.slug}`}
            className="group flex gap-3 rounded-xl border border-gray-200 p-3 transition-all hover:border-gray-300 hover:shadow-sm"
          >
            {/* Thumbnail */}
            <div className="relative w-20 h-20 shrink-0 overflow-hidden rounded-lg bg-gray-200">
              {post.image && (
                <Image
                  fill
                  src={post.image}
                  alt={post.title}
                  sizes="64px"
                  className="object-cover"
                />
              )}
            </div>

            {/* Text */}
            <div className="min-w-0 flex-1">
              <p className="mb-1 text-[10px] font-semibold uppercase tracking-wider text-[#9573F7]">
                {post.category}
              </p>
              <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-gray-900 transition-colors group-hover:text-[#9573F7]">
                {post.title}
              </h3>
              <p className="mt-1 flex items-center gap-1 text-xs text-gray-400">
                <Clock className="w-3 h-3" />
                {post.readTime}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
